import "./SettingsBar.scss";

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BoardSelector from "./BoardSelector";
import OrientationSelector from "./OrientationSelector";
import KeySelector from "./KeySelector";
import StringLayoutSelector from "./StringLayoutSelector";
import Setting from "./Setting";

function SettingsBar({ displayType, selectedKeyNumber }) {
	return (
		<div className="settings-bar">
			<Setting name="key" title="Key">
				<KeySelector selectedKeyNumber={selectedKeyNumber} />
			</Setting>
			{ !displayType ? (
				<>
					<Setting name="tool" title="Tool" />
					<Setting name="boards" title="Boards">
						<BoardSelector />
					</Setting>
					<Setting name="orientation" title="Orientation">
						<OrientationSelector />
					</Setting>
				</>
			) : null }
			<Setting name="string-layout" title="String layout">
				<StringLayoutSelector />
			</Setting>
		</div>
	);
}

SettingsBar.propTypes = {
	displayType: PropTypes.string,
	selectedKeyNumber: PropTypes.number
};

SettingsBar.defaultProps = {
	displayType: "",
	selectedKeyNumber: undefined
};

const mapStateToProps = function (state) {
	let {
		meta: {
			fretboardConfig,
			orientation,
			selectedKey,
			stringLayout
		}
	} = state;

	return {
		fretboardConfig,
		orientation,
		selectedKeyNumber: selectedKey,
		stringLayout
	};
};

export default connect(mapStateToProps)(SettingsBar);
